function pathDecoratorPlugin(options) {
    return function () {
        var decorator = function (span) {
            return span.setTags({ path: window.location.pathname });
        };
        this.addDecorator(decorator);
    };
}
export var plugin = pathDecoratorPlugin;
//# sourceMappingURL=index.js.map